import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Product } from '../product';
import { ProductService } from '../product.service';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { EditProductDialogueComponent } from '../edit-product/edit-product-dialogue/edit-product-dialogue.component';
import { saveAs } from 'file-saver-es';
import { ProductPayloadService } from '../product-payload/product-payload.service';
import { mergeMap } from 'rxjs/operators';
import { EMPTY, iif } from 'rxjs';
import { ProductDeletionDialogComponent } from '../product-deletion-dialog/product-deletion-dialog.component';

@Component({
  selector: 'app-product-management-card',
  templateUrl: './product-management-card.component.html',
  styleUrls: ['./product-management-card.component.scss'],
})
export class ProductManagementCardComponent implements OnInit {
  @Input() product: Product | undefined;
  @Output() productDeleted = new EventEmitter<string>();
  cardImage = 'assets/images/no-product.svg';

  constructor(
    private readonly productService: ProductService,
    private readonly productPayloadService: ProductPayloadService,
    public dialog: MatDialog
  ) {}

  ngOnInit(): void {
    this.setProductImage();
  }

  updateProduct(product: Product): void {
    this.product = product;
    this.setProductImage();
  }

  openEditDialog(): void {
    const dialogRef = this.dialog.open(EditProductDialogueComponent, {
      width: '500px',
      data: { product: this.product },
    });

    dialogRef.afterClosed().subscribe((result: Product) => {
      if (result) {
        this.updateProduct(result);
      }
    });
  }

  openDeleteDialog(): void {
    const dialogRef = this.dialog.open(ProductDeletionDialogComponent);

    dialogRef
      .afterClosed()
      .pipe(
        mergeMap((result: boolean) =>
          iif(
            () => result,
            this.productService.delete(this?.product?.id!),
            EMPTY
          )
        )
      )
      .subscribe(() => this.productDeleted.emit(this.product?.id));
  }

  download(): void {
    this.productPayloadService
      .downloadProduct(this.product?.id!)
      .subscribe((blob: Blob) => saveAs(blob, this.product?.name));
  }

  private setProductImage(): void {
    const imagesUrls = this.productService.getProductImagesUrlsCacheBreaking(
      this.product!
    );
    if (imagesUrls.length > 0) {
      this.cardImage = imagesUrls[0];
    }
  }
}
